// react
import { createRef } from 'react';
// @mui
import { Box, Container, Grid, Typography, Button, Stack } from '@mui/material';
import { ArrowBack, ArrowForward } from '@mui/icons-material';
// react-slick
import Slider from 'react-slick';

//----------------------------------------------------------------------------

export default function CardsSlider({ title, cards, CardComponent, slidesToShow = 3, backgroundColor="#f7f7f7" }) {
  const cardsSlider = createRef();
  const goNext = () => {
    cardsSlider.current.slickNext();
  };
  const goPrev = () => {
    cardsSlider.current.slickPrev();
  };
  const cardsettings = {
    slidesToShow: cards?.length <= slidesToShow ? cards?.length - 1 || 1 : slidesToShow,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: '60px',
    infinite: true,
    responsive: [
      {
        breakpoint: 1200,

        settings: { slidesToShow: 2 },
      },
      {
        breakpoint: 600,
        settings: { slidesToShow: 1, centerPadding: '0' },
      },
    ],
  };
  return (
    <Box className="eventPageBox" sx={{backgroundColor:backgroundColor}}>
      <Container spacing={2} maxWidth="lg">
        {title && (
          <Grid container>
            <Grid item sm={11.5} md={11.95} lg={11.9}>
              <Typography variant="h4" textAlign="center">
                {title}
              </Typography>
            </Grid>
          </Grid>
        )}
        <Stack flexDirection="column" justifyContent="center">
          {cards.length > 0 && (
            <Slider ref={cardsSlider} {...cardsettings} lazyLoad>
              {cards.map((card, index) => {
                return <CardComponent key={index} card={card} />;
              })}
            </Slider>
          )}
        </Stack>
        {cards?.length > 1 && (
          <Grid container spacing={3} justifyContent="center">
            <Grid item>
              <Button className="carouselButton" onClick={() => goPrev()}>
                <ArrowBack />
              </Button>
            </Grid>
            <Grid item>
              <Button className="carouselButton" onClick={() => goNext()}>
                <ArrowForward />
              </Button>
            </Grid>
          </Grid>
        )}
      </Container>
    </Box>
  );
}
